import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_APARTMENT_SPECIAL_DEAL_GET_LIST } from 'api/actionTypes';

export default async function getApartmentSpecialDealsByApartmentId(
  { state, apiClient },
  { apartmentId },
) {
  typeCheck('apartmentId::Number', apartmentId);

  const statePath = ['apartments', 'specialDealsByApartmentId', apartmentId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_SPECIAL_DEAL_GET_LIST,
    state: state,
    payload: {
      apartmentId: apartmentId,
    },
    onSuccess(apartmentSpecialDeals) {
      if (apartmentSpecialDeals) {
        state.set(statePath, apartmentSpecialDeals);
      }
    },
  });
}
